/**
 * B组 主题适配器
 * 将 B组 风格锁定为系统唯一主题，无需用户切换
 * Feature: B组风格全局化
 */
import React, { createContext, useContext } from 'react';

/** B组风格类型（锁定为 B组，不再支持多主题切换） */
export type ThemeType = 'bzu' | 'cyber' | 'glass' | 'neumorph' | 'light' | 'dark';

interface ThemeContextType {
  currentTheme: ThemeType;
  /** 锁定主题，此方法保留但无实际效果 */
  setTheme: (theme: ThemeType) => void;
  /** 已废弃，保留接口兼容性 */
  isAutoMode: boolean;
  /** 已废弃，保留接口兼容性 */
  setAutoMode: (auto: boolean) => void;
}

const ThemeContext = createContext<ThemeContextType>({
  currentTheme: 'bzu',
  setTheme: () => {},
  isAutoMode: false,
  setAutoMode: () => {},
});

export const useTheme = () => useContext(ThemeContext);

interface ThemeAdaptorProviderProps {
  children: React.ReactNode;
}

/**
 * B组主题提供者
 * 所有样式均通过全局 ConfigProvider 的 themeConfig 统一控制
 */
export const ThemeAdaptorProvider: React.FC<ThemeAdaptorProviderProps> = ({ children }) => {
  // 锁定为 B组 风格，setTheme 保留但无实际效果（避免历史代码报错）
  const setTheme = () => {};
  const setAutoMode = () => {};

  return (
    <ThemeContext.Provider
      value={{
        currentTheme: 'bzu',
        setTheme,
        isAutoMode: false,
        setAutoMode,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};
